import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
//Components
import TextField from '../../../components/TextField/TextField';
import TabelaQuestao from './TabelaQuestao';

//Helpers
import mascaras from '../../../helpers/mascaras';
import { showQuestion } from '../../../helpers/message';
import uuid from '../../../helpers/guid';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial da questão
function initialStateQuestao() {
    return {
        sequencia: "",
        identificacao: "",
        tipoValor: null,
        obrigatorio: false,
        possuiDependencia: false,
        opcoes: [],
        questoesDependentes: [],
        questaoVinculada: null,
        valorQuestaoVinculada: "",
        opcoesQueGeramInconformidade: [],
        hash: "",
        tipoFotografia: "Foto"
    }
}

//Estado inicial da questão dependente
function initialStateQuestaoDependente() {
    return {
        questaoPai_UUID: "",
        questaoPai_Valor: "",
    }
}
export default function Questao({ formulario, setFormulario, openFormQuestao, setOpenFormQuestao }) {
    //Estado de controle dos errors
    const [errors, setErrors] = useState({});

    //Estado de controle das opções das questões vinculadas
    const [optionsQuestoesVinculadas, setOptionsQuestoesVinculadas] = useState(formulario.questoes.map((value, index) => { return { label: value.identificacao, value: value.hash } }));

    //Estado de controle da questão dependente
    const [questaoDependente, setQuestaoDependente] = useState(initialStateQuestaoDependente);

    //Ações da tabela de cabeçalhos
    const actions = [
        actionsTable.editar((rowData) => {

            if (formulario.questoes[rowData.tableData.id].possuiDependencia && formulario.questoes[rowData.tableData.id].id) {
                setQuestaoDependente(formulario.questoes[rowData.tableData.id].questoesDependentes.filter(v => v.tbFormularioVistoriaQuestao_Id == formulario.questoes[rowData.tableData.id].id)[0]);
            } else if (formulario.questoes[rowData.tableData.id].possuiDependencia) {
                setQuestaoDependente(formulario.questoes[rowData.tableData.id].questoesDependentes[0]);
            }
            setQuestao(formulario.questoes[rowData.tableData.id]);
            setOpenFormQuestao(true);
        }),
        actionsTable.remover((rowData) => {
            showQuestion("Tem certeza disso?", "Você tem certeza de que deseja remover esta questão? Esta é uma ação irreversível", "warning", (confirmation) => removerQuestao(rowData, confirmation));
        })
    ]

    //Função que remove uma questao
    const removerQuestao = (questao, confirmacao) => {
        if (confirmacao) {

            setFormulario({
                ...formulario,
                questoes: formulario.questoes.filter(item => item.id != questao.id)
            })
            setQuestao(initialStateQuestao());
            setOpenFormQuestao(false);
        }
    }

    //Estado de controle dos dados da questao
    const [questao, setQuestao] = useState(initialStateQuestao);

    //onChange para os campos de texto do formulario de cabeçalho
    const onChangeTexto = (e) => {
        const { name, value } = e.target;
        setQuestao({
            ...questao,
            [name]: value
        });
    }

    //onChange para o campo de valor da questão dependente
    const onChangeTextoQuestaoPai = (e) => {
        const { name, value } = e.target;
        setQuestaoDependente({
            ...questaoDependente,
            [name]: value
        });
    }

    //onChange para o campo de select de tipo de valor
    const onChangeTipoValor = (e, select) => {
        if (e.value == "Lista") {
            setCamposObrigatorios([
                ...camposObrigatorios,
                objCampo({ name: "opcoes", required: true })
            ])
        } else {
            setCamposObrigatorios([...camposObrigatorios.filter(v => v.name != "opcoes")]);
        }
        setQuestao({
            ...questao,
            opcoes: e == null || e.value != "Lista" ? [] : questao.opcoes,
            [select.name]: e != null ? e.value : null
        })
    }

    //onChange para a questão vinculada
    const onChangeQuestaoVinculada = (e, select) => {
        setQuestaoDependente({
            ...questaoDependente,
            [select.name]: e != null ? e.value : null
        })
    }

    //OnChange para o checkbox
    const onChangeCheckbox = (e) => {
        const { name, checked } = e.target;
        setQuestao({
            ...questao,
            [name]: checked
        })
    }

    //OnChange para o campo de opções de resposta
    const onChangeOpcoes = (inputValue) => {
        const opcoesQueGeramInconformidade = questao?.opcoesQueGeramInconformidade?.filter(op => (typeof inputValue == "object" && inputValue.filter(v => v.value == op.value).length > 0) || typeof inputValue != "object");
        setQuestao({
            ...questao,
            opcoesQueGeramInconformidade,
            opcoes: typeof inputValue === "object" ? [...inputValue] : [...questao.opcoes, { value: inputValue, label: inputValue }]
        });
    }

    //OnChange para o campo de opções de resposta
    const onChangeOpcoesQueGeramInconformidade = (e, select) => {
        setQuestao({
            ...questao,
            [select.name]: e
        });
    }


    //Opções dos selects de tipo de valor
    const optionsTipoValor = [
        { label: "Data", value: "Data" },
        { label: "Lista", value: "Lista" },
        { label: "Número", value: "Número" },
        { label: "Texto", value: "Texto" }
    ];

    const oprionsTipoFotografia = [
        { text: "Foto", value: "Foto" },
        { text: "Documento", value: "Documento" },
    ];

    //Campos obrigatorios no cadastro de um novo cabeçalho
    const [camposObrigatorios, setCamposObrigatorios] = useState([
        objCampo({ name: "sequencia", required: true }),
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "tipoValor", required: true }),
    ]);

    //Campos obrigatorios da questão dependente no cadastro de um novo cabeçalho
    const camposObrigatoriosQuestaoDependente = [
        objCampo({ name: "questaoPai_UUID", required: true }),
        objCampo({ name: "questaoPai_Valor", required: true }),
    ];
    //Função que adiciona uma questão a lista
    const adicionarQuestao = () => {
        //validando os campos
        const _errors = validarCampos(questao, camposObrigatorios);
        let _errorsQuestaoDependente = [{}, []];
        if (questao.possuiDependencia) {
            _errorsQuestaoDependente = validarCampos(questaoDependente, camposObrigatoriosQuestaoDependente);
        }
        setErrors({ ..._errors[0], ..._errorsQuestaoDependente[0] });
        if (_errors[1].length > 0) {
            return;
        }

        //Se o tableData existir a edição da questão sera feira
        if (questao.tableData) {

            const _questoes = formulario.questoes.map((value, index) => {
                if (questao.tableData.id === index) {
                    const _questao = { ...questao };
                    if (_questao.possuiDependencia) {
                        _questao.questoesDependentes = [{ ...questaoDependente }];
                    }
                    setQuestaoDependente(initialStateQuestaoDependente);
                    return { ..._questao };
                }
                return value;
            });
            setFormulario({
                ...formulario,
                questoes: _questoes
            });
            setOptionsQuestoesVinculadas(_questoes.map((value, index) => { return { label: value.identificacao, value: value.hash } }));

        } else {
            //Se não sera adicionada a nova questão

            const _questao = { ...questao };
            if (_questao.possuiDependencia) {
                if (!_questao.id) {
                    _questao.questoesDependentes = [{ ...questaoDependente }];
                } else {
                    _questao.questoesDependentes = [..._questao.questoesDependentes.map(value => {
                        if (value.tbFormularioVistoriaQuestao_Id) {
                            return { ...questaoDependente };
                        }
                        return { ...value };
                    })];
                }
            }

            setQuestaoDependente(initialStateQuestaoDependente);
            _questao.hash = uuid();
            setFormulario({
                ...formulario,
                questoes: [...formulario.questoes, { ..._questao }]
            });
            setOptionsQuestoesVinculadas([...optionsQuestoesVinculadas, { label: _questao.identificacao, value: _questao.hash }]);
        }

        setOpenFormQuestao(false);
        setQuestao(initialStateQuestao);
    }

    return (
        <div>
            <div className={`formContainer mb-4 ${openFormQuestao ? "" : "close"}`}>
                <Row >
                    <Col md="12" lg="4">
                        <TextField
                            invalid={!!errors.sequencia}
                            label={"* Sequência"}
                            onChange={onChangeTexto}
                            name={"sequencia"}
                            value={questao.sequencia}
                            mask={mascaras.numeroMask}
                        />
                    </Col>
                    <Col md="12" lg="8">
                        <TextField
                            invalid={!!errors.identificacao}
                            label={"* Identificação"}
                            onChange={onChangeTexto}
                            name={"identificacao"}
                            value={questao.identificacao}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            invalid={!!errors.tipoValor}
                            label={"* Tipo de valor"}
                            options={optionsTipoValor}
                            type="select" searchable
                            onChange={onChangeTipoValor}
                            name={"tipoValor"}
                            value={questao.tipoValor != null ? optionsTipoValor.filter(v => v.value === questao.tipoValor)[0] : null}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            invalid={!!errors.tipoValor}
                            label={"* Tipo de Fotografia"}
                            options={oprionsTipoFotografia}
                            type="select" 
                            onChange={onChangeTexto}
                            name={"tipoFotografia"}
                            value={questao.tipoFotografia}
                        />
                    </Col>
                    <Col md="12" lg="2" className='mt-2'>
                        <TextField
                            label={"Campo obrigatório"}
                            type="checkbox"
                            onChange={onChangeCheckbox}
                            value={questao.obrigatorio}
                            name={"obrigatorio"}
                        />
                    </Col>

                    <Col md="12" lg="2" className='mt-2'>
                        <TextField
                            label={"Possui dependência"}
                            type="checkbox"
                            onChange={onChangeCheckbox}
                            value={questao.possuiDependencia}
                            name={"possuiDependencia"}
                        />
                    </Col>
                    {questao.tipoValor === "Lista" &&
                        <>
                            <Col md="12" lg="12" className='mt-2'>
                                <TextField
                                    invalid={!!errors.opcoes}
                                    label={"* Opções de resposta"}
                                    type="select"
                                    creatable
                                    name={"opcoes"}
                                    onChange={onChangeOpcoes}
                                    value={questao.opcoes}
                                />
                            </Col>
                            <Col md="12" lg="12" className='mt-2'>
                                <TextField
                                    label={"Opções que geram inconformidade"}
                                    type="select"
                                    options={questao.opcoes}
                                    multiple
                                    name={"opcoesQueGeramInconformidade"}
                                    onChange={onChangeOpcoesQueGeramInconformidade}
                                    value={questao.opcoesQueGeramInconformidade} />
                            </Col>
                        </>
                    }
                    {questao.possuiDependencia && (
                        <>
                            <Col lg="6" className='mt-2'>
                                <TextField
                                    invalid={!!errors.questaoPai_UUID}
                                    label={"* Questão vinculada"}
                                    type="select"
                                    searchable
                                    name={"questaoPai_UUID"}
                                    onChange={onChangeQuestaoVinculada}
                                    value={questaoDependente.questaoPai_UUID != null ? optionsQuestoesVinculadas.filter(v => v.value === questaoDependente.questaoPai_UUID)[0] : null}
                                    options={optionsQuestoesVinculadas.filter(v => v.value !== questao?.hash)}
                                />
                            </Col>
                            <Col lg="6" className='mt-2'>
                                <TextField
                                    invalid={!!errors.questaoPai_Valor}
                                    label={"* Resposta da questão vinculada"}
                                    searchable
                                    name={"questaoPai_Valor"}
                                    onChange={onChangeTextoQuestaoPai}
                                    value={questaoDependente.questaoPai_Valor}
                                />
                            </Col>
                        </>
                    )}
                </Row>
                <div className='w-100 d-flex align-items-center justify-content-center'>
                    <Button color='success' onClick={adicionarQuestao}><FontAwesomeIcon icon={faSave} /> <span className="fw-bold">Salvar</span></Button>
                </div>
            </div>
            <TabelaQuestao actions={actions} items={formulario.questoes} />
        </div>
    );
}